// src/components/Loading.js
import React from "react";

const Loading = () => {
  return (
    <div className="loading">
      <div className="spinner"></div>
      <p className="loading-text">処理中...</p>
    </div>
  );
};

export default Loading;
